
import {timer as observableTimer, combineLatest as observableCombineLatest,  Subscription ,  Observable } from 'rxjs';

import {filter, tap} from 'rxjs/operators';
import { Component, OnDestroy, EventEmitter, ElementRef, ViewChild, Output, Renderer2, Input } from '@angular/core';
import { NotificationsMenuService } from './notifications-menu.service';
import { AppState } from '../../../interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { DialogsService } from '../../../services/dialogs.service';
import { FeedbackAudio } from '../feedback-audio.class';
import { NotificationStatusEnum } from '../../../models/communication/Notification.model';
import { NotificationsAction } from '../../../state-management/notifications/notifications.actions';
import { NotificationsOverlayList } from '../notifications-overlay-list/notifications-overlay-list.component';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe/dist/auto-unsubscribe';
import { NotificationsEffects } from '../../../state-management/notifications/notifications.effects';
import { TrackingActions } from '../../../state-management/tracking/tracking.action';


const howler = require('howler');
@AutoUnsubscribe()
@Component({
    selector: 'notifications-menu',
    templateUrl: 'notifications-menu.component.html',
    styleUrls: ['notifications-menu.component.scss']
})

export class NotificationsMenuComponent implements OnDestroy {
    // Elements to manipule events
    public amountHoverText: string;
    public amountIconText: string;
    public notificationsItens: any;
    public notificationsLoading: boolean;
    public unreadNotifications = [];
    public notPrioritaryRequestsSubscription: Subscription;
    public  notifications = [];

    @Input()
    public bgColorClass: 'darker' | 'transparent' | 'opacity' | 'default' = 'default';

    private icon;
    private number;
    private menu;
    private hover;
    private bodyHtml;
    private amount;
    private notificationSoundSrc: string = 'assets/audio/sound_2.m4a';
    private notificationSound: any;
    private receivedHistoricSubscription: Subscription;
    public userIdentifier: string;

    // emitte event whan menu is open(true) or close(false)
    @Output() open: EventEmitter<any> = new EventEmitter();
    @ViewChild('icon', {static: true}) iconElement: ElementRef;

    private feedbackAudio;

    private attendences: Array<any> = [];
    private storeSubscription: Subscription;
    private notificationsEffectsSubscription: Subscription;


    constructor(
        private _r: Renderer2,
        private _elRef: ElementRef,
        private _nS: NotificationsMenuService,
        private store: Store<AppState>,
        private dialogService: DialogsService,
        private notificationsEffects: NotificationsEffects,
    ) {
        this.feedbackAudio = new FeedbackAudio("/assets/audio/sound_2.m4a", 5000);

        this.notificationSound = new howler.Howl({
            src: [this.notificationSoundSrc],
            volume: 1,
            loop: false,
            html5: true
        });

        this.storeSubscription = observableCombineLatest(
            this.store.select(s => s.notifications),
            this.store.select(s => s.salesforce)
        ).pipe(tap(([notifications, salesforce]) => this.notificationsLoading = notifications.pending),
        filter(([notifications, salesforce]) => (notifications && !notifications.pending) && (salesforce && !salesforce.pending)),)
        .subscribe(([notifications, salesforce]) => {
            this.attendences = [...salesforce.attendences].map(item => {
                return {
                    body: `Avalie seu atendimento sobre "${item.subject}"`,
                    details: null,
                    messageID: null,
                    readStatus: 0,
                    // Deixar sem uma data temporariamente enquanto implementação não ocorre em back
                    sendDate: '',
                    attendence: item
                }
            });
            this.notifications = [...[], ...this.attendences, ...notifications.notifications];
            this.unreadNotifications = [...[], ...this.notifications.filter(notification => notification && (notification.readStatus == NotificationStatusEnum.unread))];
            this.notifications.splice(5);
        
            this.store.select((state) => state.userProfile)
                .subscribe((userData) => {
                    this.userIdentifier = userData.user.cpfcnpj;
                });

        });

    }

    ngAfterViewInit() {

        this.getElements();
        this.createShowMenuEvent();

        // Subscribes for GET AND/OR UPDATE
        this.subscribe_AmoutNotifications();
        this.subscribe_Notifications();

        // Requisitar histórico de notificações 10s depois do carregamento
        this.notPrioritaryRequestsSubscription = observableTimer(10000).subscribe(() => {
            this.store.dispatch({ type: NotificationsAction.getNotifications });
            this.store.dispatch({ type: NotificationsAction.subscribeNotificationChannel });
        });

        this.notificationsEffectsSubscription = this.store
            .select(s => s.notifications.realtimeNotification).pipe(
            filter(notification => notification && this.iconElement ? true : false ))
            .subscribe(data => {
                this.iconElement.nativeElement.classList.add('shake');
                this.notificationSound.play();
                setTimeout(() => this.iconElement.nativeElement.classList.remove('shake'), 1000);
            });
    }

    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }

    getElements() {
        this.icon = this._elRef.nativeElement.querySelector('#navbar-notifications');
        this.number = this._elRef.nativeElement.querySelector('#navbar-notifications-number');
        this.menu = this._elRef.nativeElement.querySelector('#notifications-menu');
        this.hover = this._elRef.nativeElement.querySelector('#notifications-hover');
    }

    /**
     * UPDATE VIEW
     *
     * @param amount
     */

    setAmountHoverText(amount) {
        if (amount) {
            this.amountHoverText = `Você tem <b>${amount} ${(amount == 1) ? 'mensagem</b> nova' : 'mensagens</b> novas'}`;
            this._r.addClass(this.hover, 'active');
        }
        else {
            this._r.removeClass(this.hover, 'active');
        }
    }

    setAmountIconText(amount) {
        if (amount) {
            this.amountIconText = (amount >= 10) ? '9+' : String(amount);
            this._r.addClass(this.number, 'active');
        }
        else {
            this._r.removeClass(this.number, 'active');
        }
    }

    /**
     * EVENTS
     *
     * Create events for open and close menu
     */

    createShowMenuEvent() {
        let showMenuEvent = this._r.listen(this.icon, 'click', (event) => {
            event.stopPropagation();
            this.menu.firstElementChild.scrollTop = 0; // scroll top container notifications

            this.getAndUpdate_Notifications(); // get more notifications

            this.open.emit(true); // Emitte event when menu is open
            this._r.addClass(this.menu, "active"); // set menu class active when is open
            this.createHideMenuEvent(); // create event to close menu
            showMenuEvent(); // destroy event open menu
        });
    }

    createHideMenuEvent() {
        let hideMenuEvent = this._r.listen(document, 'click', () => {

            this.open.emit(false); // Emitte event when menu is close

            this._r.removeClass(this.menu, "active");
            this.createShowMenuEvent(); // create event to open menu again
            hideMenuEvent(); // destroy event hide menu
        });
    }

    /**
     * GET AND/OR UPDATE
     *
     * methods to get/update amout notifications and menu notifications
     */

    subscribe_Notifications() {
        // this._nS.notificationsObservable$.subscribe(notificationsArray => {
        //     this.notificationsItens = notificationsArray
        //     this.notificationsLoading = false;
        // })
    }

    subscribe_AmoutNotifications() {
        this._nS.amoutObservable$.subscribe((amount) => {
            this.amount = amount;
            this.setAmountHoverText(amount);
            this.setAmountIconText(amount);
            this.feedbackAudio.play();
        })

        // start channel for updates
        this._nS.getAndUpdate_AmoutNotifications();
    }

    getAndUpdate_Notifications() {
        // this.notificationsLoading = true;
        // this._nS.getAndUpdate_Notifications();
    }

    openOverlay() {
        this.dialogService.showComponnent( NotificationsOverlayList )
    }

    public clickInMenu() {
        const payloadUser = {type: 'User Clicked', events: { userLogin: this.userIdentifier, path: window.location.pathname, element: 'Link Notificação'}};
        this.store.dispatch({type: TrackingActions.trackEvents, payload: payloadUser});
    }

}
